import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const categories = [
  {
    img: "/images/network/mumbai.jpg",
    name: "Mumbai",
  },
  {
    img: "/images/network/goa.jpg",
    name: "Goa",
  },
  {
    img: "/images/network/lonavla.jpg",
    name: "Lonavala",
  },
  {
    img: "/images/network/mahabaleshwar.jpg",
    name: "Mahabaleshwar",
  },
  {
    img: "/images/network/lavasa.jpg",
    name: "Lavasa",
  },
  {
    img: "/images/network/alibag.jpg",
    name: "Alibag",
  },
];

const CategoriesSection = () => {
  return (
    <div className="section-full p-t150 site-bg-white twm-categories-section-wrap wow fadeInDown">
      <div className="container">

        {/* TITLE */}
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="section-head left">
              <div className="twm-sm-title left">Top Destinations</div>

              <h2 className="twm-large-title site-text-dark">
                Explore Popular Travel Cities
              </h2>
            </div>
          </div>
        </div>

        {/* CAROUSEL */}
        <div className="section-content">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={20}
            slidesPerView={3}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            navigation={true}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 2 },
              768: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
          >
            {categories.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="twm-categories-type">
                  
                  <div className="twm-media">
                    <img src={item.img} alt={item.name} />

                    <div className="twm-media-link">
                      <a
                        href="#"
                        className="twm-media-link-content"
                      >
                        {item.name}
                      </a>
                    </div>

                  </div>

                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

      </div>
    </div>
  );
};

export default CategoriesSection;